import BigNumber from 'bignumber.js';

/**
 * Lambda ƛ (Leverage Ratio): Represents the option’s effective leverage.
 * It is calculated as the dollar delta relative to the option’s mark price.
 */
export function optionLeverageRatio(
  delta: BigNumber,
  spotPrice: BigNumber,
  markPrice: BigNumber,
) {
  return delta.times(spotPrice).dividedBy(markPrice);
}
